export default {
  methods: {
    getFontSizeForChatInterface(field) {
      const fontSize = this.$getFontSize(field, {
        forChatInterface: true,
        forIntentResponse: false
      })
      const lineHeight = this.$getLineHeightForFontSize(fontSize)
      return { fontSize, lineHeight }
    },
    getFontSizeForResponse(field, forIntentResponse = true) {
      const fontSize = this.$getFontSize(field, {
        forChatInterface: false,
        forIntentResponse: forIntentResponse
      })
      const lineHeight = this.$getLineHeightForFontSize(fontSize)
      return { fontSize, lineHeight }
    },
  }
}
